import React from 'react';
import { Sparkles, Star } from 'lucide-react';

export const AboutSection = () => (
  <section id="about" className="py-24 bg-white">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-5xl font-serif text-[#8B7355] mb-6 italic">Our Story</h2>
          <p className="text-lg text-[#8B7355]/80 mb-6 leading-relaxed">
            Shot to the Nines came from wanting to build something better than the standard
            photo booth — something that actually adds to your event, not just fills a space.
          </p>
          <p className="text-lg text-[#8B7355]/80 mb-6 leading-relaxed">
            Every part of the booth has been built by hand, from the frame right through to
            the details, with a focus on creating something that looks like it belongs at a
            wedding, not something that feels hired in.
          </p>
          <p className="text-lg text-[#8B7355]/80 mb-6 leading-relaxed">
            For you, that means your guests aren't just walking past it — they're drawn to it.
            It becomes part of the night, something people use, talk about, and remember.
          </p>
          <p className="text-lg text-[#8B7355]/80 mb-8 leading-relaxed">
            The goal is simple: give you a setup that looks great, runs smoothly, and gives
            your guests something real to take home — while making your event feel that little
            bit more special.
          </p>

          <div className="grid grid-cols-2 gap-6">
            <div className="text-center p-6 bg-[#F5F1E8] rounded-lg">
              <Sparkles className="w-10 h-10 text-[#C9A961] mx-auto mb-3" />
              <h3 className="font-serif text-2xl text-[#8B7355] mb-2">Quality</h3>
              <p className="text-sm text-[#8B7355]/70">Over Everything</p>
            </div>
            <div className="text-center p-6 bg-[#F5F1E8] rounded-lg">
              <Star className="w-10 h-10 text-[#C9A961] mx-auto mb-3" />
              <h3 className="font-serif text-2xl text-[#8B7355] mb-2">Handbuilt</h3>
              <p className="text-sm text-[#8B7355]/70">Piece by Piece</p>
            </div>
          </div>
        </div>

        <div className="relative h-[700px] flex items-center justify-center">
          <div className="absolute w-full h-[95%] bg-[#C9A961]/20 rounded-lg transform rotate-2"></div>
          <div className="relative w-[90%] h-[90%] flex items-center justify-center">
            <img
              src="/booth5.jpg"
              alt="Full Vintage Booth - Shot to the Nines"
              className="rounded-lg shadow-2xl max-h-full max-w-full object-contain"
              style={{ transform: 'rotate(-90deg)' }}
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
